import { h } from 'preact';
import Logo from '../Logo/Logo';

function Footer() {
  return (
    <section class="bg-white text-gray-600 relative z-10">
      <footer class="container mx-auto px-8 lg:px-36 py-6 flex flex-col items-center space-y-4 sm:flex-row sm:space-y-0 justify-between">
        <a href="/">
          <Logo className="text-gray-400 hover:text-gray-500" />
        </a>
        <div class="text-sm text-center sm:text-right font-medium">
          <p>
            © 2020 - present
            {' '}
            <a href="https://akashhamirwasia.com" class="text-purple-600 font-semibold">Akash Hamirwasia</a>
          </p>
          <p class="mt-1">
            Released under
            {' '}
            <a href="https://github.com/blenderskool/untab/blob/master/LICENSE" class="text-purple-600 font-semibold">MIT License</a>
          </p>
        </div>
      </footer>
    </section>
  );
}

export default Footer;
